import {SET_USER_DATA, SET_LANGUAGE, REFERRER_USER, COLOR_BRANDING} from './login.actionTypes'




export function setUserData(data:any): any {
   // console.log("userInfo====>IN Action",data)
    return (dispatch: any) => {
        dispatch({
            type: SET_USER_DATA,
            payload:data
        });
    }
}

export function setLanguage(data:any): any {
   // console.log("userInfo====>IN Action",data)
    return (dispatch: any) => {
        dispatch({
            type: SET_LANGUAGE,
            payload:data
        });
    }
}

export function setReferrenUserInfo(data:any): any {
    return (dispatch: any) => {
        dispatch({
            type: REFERRER_USER,
            payload:data
        });
    }
}

export function setClient(client:any): any {
   // console.log('36363636363636',client);
    return (dispatch: any) => {
        dispatch({
            type: COLOR_BRANDING,
            payload:client
        });
    }
}